import { ReactElement, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { appendTestableComponentAttributes, Card, StyledFlex, TestableComponentProps } from '@dreryk/react-components';

export const StyledPrescriptionCard = styled(Card)<{ $annulled: boolean }>`
   border-radius: 16px;
   padding: 10px 12px 12px 12px;

   ${({ $annulled, theme }) =>
      $annulled &&
      css`
         background: ${theme.errorLightest};
      `}
`;

StyledPrescriptionCard.displayName = 'StyledPrescriptionCard';

export type PrescriptionCardProps = {
   readonly children?: ReactNode | null;
   readonly heading: ReactElement;
   readonly subheading: ReactElement;
   readonly options?: ReactElement | null;
   readonly annulled?: ReactElement | null;
} & TestableComponentProps;

export const PrescriptionCard = (props: PrescriptionCardProps): JSX.Element => {
   const { testId, children, heading, subheading, options, annulled } = props;

   return (
      <StyledPrescriptionCard
         cardType={'container'}
         $annulled={Boolean(annulled)}
         {...appendTestableComponentAttributes('PrescriptionCard', testId)}
      >
         <StyledFlex direction={'column'} gap={'8px'}>
            <StyledFlex direction={'row'} gap={'8px'} justifyContent={'space-between'} alignItems={'flex-start'}>
               <StyledFlex direction={'column'} gap={'2px'}>
                  <StyledFlex direction={'row'} gap={'8px'} alignItems={'center'}>
                     {annulled}
                     {heading}
                  </StyledFlex>
                  {subheading}
               </StyledFlex>
               <StyledFlex direction={'row'} gap={'4px'}>
                  {options}
               </StyledFlex>
            </StyledFlex>
            {children}
         </StyledFlex>
      </StyledPrescriptionCard>
   );
};
